import { updateAppNotification } from '@store/client/store.notifications';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

export type ResponseErrorNoticeType = { offline: boolean; data: { errors: string | string[]; error_title: string } };

export function displayErrors(requestResult: ResponseErrorNoticeType) {
  if (requestResult?.offline) {
    updateAppNotification({
      error_title: 'Offline',
      errors: ['It appears that the browser has lost connectivity. Please try again or contact Support.' as string],
    });
  } else {
    const { errors, error_title: errorTitle } = requestResult?.data || {};
    const title = errorTitle;
    const errorsDisplay = errors || 'It appears that there was an error. Please try again or contact Support.';

    updateAppNotification({ error_title: title, errors: errorsDisplay });
  }
}

export function setErrorsHookFormErrors<T extends FieldValues>({
  setError,
  mutationData = {},
  field,
}: {
  setError: UseFormSetError<T>;
  mutationData: any;
  field?: string;
}) {
  const data = 'data' in mutationData ? mutationData.data : mutationData;

  if (data?.formErrors) {
    Object.entries(data.formErrors as Record<string, string>).forEach(([k, v]) => setError(k as Path<T>, { type: 'manual', message: v }));
  }

  /* Single field error */
  if (field && data?.error) {
    const err = typeof data.error === 'string' ? data.error : data.error?.[field] || data.error?.[0] || 'Unknown Error';
    setError(field as Path<T>, { type: 'manual', message: err });
  }
}
